import { Stack, Typography } from '@cmg/design-system';
import React from 'react';

export type RevisionTooltipContentProps = Readonly<{
  /**
   * Formatted initial value
   */
  initialValue: string;
}>;

export const RevisionTooltipContent: React.FC<RevisionTooltipContentProps> = ({ initialValue }) => {
  return (
    <Stack flexDirection="column">
      <Typography variant="tooltip" fontWeight="bold">
        Revised
      </Typography>
      <Typography variant="caption">{initialValue}</Typography>
    </Stack>
  );
};
